import React, {useState, useEffect} from 'react';
import TextInput from '../../../../common/Form/TextInput/TextInput';
import DateRangePicker from '../../../../common/Form/DateRangePicker/DateRangePicker';
import Uploader from '../../../../common/Uploader/Uploader';
import {Container} from './GstDetails.styles';

const GstDetails = ({gstForm, handleGstFormChange, disableSubmitGstInput, regexPattern}) => {
  return (
    <Container>
      <h3>Enter GST Details</h3>
      <div className="flex">
        <div>
          <div>
            <TextInput
              labelText="Enter Invoice Number"
              isRequired={true}
              placeHolderText="Enter GST Invoice Number"
              width={'215px'}
              value={gstForm?.gstInvoiecNumber}
              onTextChange={handleGstFormChange}
              name={'gstInvoiecNumber'}
              readOnly={disableSubmitGstInput}
              maxLength={16}
              regexPattern={regexPattern}
            />
          </div>
          <span style={{marginLeft: 10, color: '#333333', fontSize: 10}}>
            Only Special characters allowed are: -/_
          </span>
        </div>
        <div className="ml24" style={{pointerEvents: disableSubmitGstInput ? 'none' : ''}}>
          <DateRangePicker
            singleDate={true}
            startLabel={'Select Invoice Date'}
            startValue={gstForm?.gstInvoiceDate}
            changeHandler={handleGstFormChange}
            name={'gstInvoiceDate'}
            readOnly={disableSubmitGstInput}
          />
        </div>
      </div>
      <div className="mt24">
        <TextInput
          labelText="Enter Remarks"
          placeHolderText="Enter Remarks"
          name={'remarks'}
          onTextChange={handleGstFormChange}
          readOnly={disableSubmitGstInput}
        />
      </div>
    </Container>
  );
};

export default GstDetails;
